const _default = (theme, disabled) => ({
  color: disabled ? theme.tokens.ComponentActionDisabled : theme.tokens.ComponentActionColor,
  textDecorationColor: theme.tokens.ComponentActionColor,
  '&:focus-visible': {
    border: 'none',
    outline: 'none',
    boxShadow: theme.tokens.SemRingFocus
  }
});
const _hover = (theme, disabled) => ({
  '&:hover': {
    color: disabled ? theme.tokens.ComponentActionDisabled : theme.tokens.ComponentActionHover,
    textDecorationColor: theme.tokens.ComponentActionHover,
    cursor: disabled ? 'not-allowed' : 'pointer'
  }
});
const _size = (theme, size) => {
  const _defaultSizeStyle = {
    fontWeight: 500,
    fontFamily: theme.tokens.ComponentActionFontFamily
  };
  switch (size) {
    case 'lg':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentActionFontSizeLg,
        lineHeight: '22.5px',
        gap: '8px'
      };
    case 'md':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentActionFontSizeMd,
        lineHeight: '20px',
        gap: '8px'
      };
    case 'sm':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentActionFontSizeSm,
        lineHeight: '18.2px',
        gap: '6px'
      };
    case 'xs':
      return {
        ..._defaultSizeStyle,
        fontSize: theme.tokens.ComponentActionFontSizeXs,
        lineHeight: '15.6px',
        gap: '4px'
      };
    default:
      return _defaultSizeStyle;
  }
};
const actionDefaultStyle = (theme, size, disabled) => ({
  '&, .ids-action': {
    ..._default(theme, disabled),
    ..._hover(theme, disabled),
    ..._size(theme, size)
  }
});
export default actionDefaultStyle;